'use strict';

const BaseView = require('components-framework/view/base.view');
const isDesktop = Odigeo.SessionScope.flow === 'desktop';
const isDynpack = Odigeo.Utils.isRequestApp('dp');
const trackingUtils = require('od-modules/utils/tracking.utils');
const minimumNumSeats = Odigeo.BagsAndSeats.minimumNumSeats;
const logger = require('od-modules/utils/logger');
const Flights = require('od-apps/app.flights');
const {fareRulesManager, fareRuleEvents} = require('od-modules/fare_rules_manager');
const {trackJQElementDisplayed, trackClickEvent} = require('od-modules/track_events/track.frontevents.utils');

module.exports = BaseView.extend({
    cons: {
        open: 'open',
    },
    selectors: {
        container: '.cheap_repricing_container',
    },
    events: {
        'tap .reject_repricing': 'rejectFromCross',
        'tap .reject_repricing_button': 'rejectFromButton',
        'tap .confirm_repricing': 'confirmRepricing',

    },
    isVisible: false,
    newPrice: 0,
    oldPrice: 0,
    shouldRenderRepricing: false,
    pricePerPaxWithDiscounts: 0,
    pricePerPaxWithoutDiscounts: 0,
    newPricePerPax: 0,
    numTravellers: 0,
    initialize() {
        const searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
        this.numTravellers = searchParameters.numAdults + searchParameters.numChildren + searchParameters.numInfants;
        this.trackRepricingDisplayed = Odigeo._.once(trackJQElementDisplayed);
        this.listenTo(this.model, 'membershipSubscriptionDetailsDTO:updated', this.checkRenderRepricing);
    },
    toggleTemplate(isVisible) {
        const $container = this.$el.find(this.selectors.container);
        $container.toggleClass(this.cons.open, isVisible);
    },
    checkRenderRepricing() {
        this.shouldRenderRepricing = true;
        this.renderRepricing();
    },
    renderRepricing() {
        const membershipSubscriptionDetails = this.model.get('membershipSubscriptionDetailsDTO');
        const primePriceSelectedInResults = membershipSubscriptionDetails?.primePriceSelectedInResults;
        this.trackRepricingDisplayed(this.$el);
        const oldPriceFormatted = Odigeo.Utils.splitFormatedCurrency(this.oldPrice);
        const newPriceFormatted = Odigeo.Utils.splitFormatedCurrency(this.newPrice);
        const pricePerPaxWithDiscountsFormatted = Odigeo.Utils.splitFormatedCurrency(this.pricePerPaxWithDiscounts);
        const pricePerPaxWithoutDiscountsFormatted = Odigeo.Utils.splitFormatedCurrency(this.pricePerPaxWithoutDiscounts);
        let lowAcceptanceRepricingPricePerPax = primePriceSelectedInResults ? pricePerPaxWithDiscountsFormatted
            : pricePerPaxWithoutDiscountsFormatted;
        lowAcceptanceRepricingPricePerPax = Odigeo.AB.isPrimeEnabled ? lowAcceptanceRepricingPricePerPax : pricePerPaxWithDiscountsFormatted;
        const data = {
            minimumNumSeats: minimumNumSeats,
            pluralizeAll: Odigeo.Utils.pluralizeAll,
            keys: this.keys,
            options: this.options,
            oldPrice: oldPriceFormatted,
            newPrice: newPriceFormatted,
            pricePerPaxWithDiscounts: pricePerPaxWithDiscountsFormatted,
            pricePerPaxWithoutDiscounts: pricePerPaxWithoutDiscountsFormatted,
            lowAcceptanceRepricingPricePerPax: lowAcceptanceRepricingPricePerPax,
            rejectRepricingVisibilityClass: Odigeo.AB.isRejectRepricingDisabled ? 'odf-hidden' : '',
        };
        logger.message(`Showing cheap repricing with info:
            | oldPriceFormatted: ${oldPriceFormatted}
            | newPriceFormatted: ${newPriceFormatted}
            | numTravellers: ${this.numTravellers}
            | lowAcceptanceRepricingPricePerPax: ${lowAcceptanceRepricingPricePerPax}
            | pricePerPaxWithoutDiscountsFormatted: ${pricePerPaxWithoutDiscountsFormatted}
            | pricePerPaxWithDiscountsFormatted: ${pricePerPaxWithDiscountsFormatted}`);
        this.$el.html(this.templates.main(data));
        this.toggleTemplate(true);
        trackingUtils.trackEvent('repricing_popup',
            `repricing_appearances_iprice:${this.oldPrice}_fprice:${this.newPrice}_pax:${this.numTravellers}_meta`);
        Odigeo.Session.remove('repricingMAPI');
    },
    renderMetasRepricing(totalPriceDifference, repricingMAPI) {
        this.oldPrice = repricingMAPI ? repricingMAPI.oldPrice : 0;
        this.newPrice = repricingMAPI ? repricingMAPI.newPrice : 0;
        this.pricePerPaxWithDiscounts = repricingMAPI ? repricingMAPI.pricePerPaxWithDiscounts : 0;
        this.pricePerPaxWithoutDiscounts = repricingMAPI ? repricingMAPI.pricePerPaxWithoutDiscounts : 0;

        if (this.shouldRenderRepricing) {
            this.renderRepricing();
        }
    },
    close() {
        this.toggleTemplate(false);
    },
    rejectFromButton(event) {
        trackClickEvent(event);
        const rejectOrigin = 'find';
        this.rejectRepricing(rejectOrigin);
    },
    rejectFromCross() {
        const rejectOrigin = 'close';
        this.rejectRepricing(rejectOrigin);
    },
    rejectRepricing(rejectOrigin) {
        trackingUtils.trackEvent('repricing_popup',
            `repricing_${rejectOrigin}_iprice:${this.oldPrice}_fprice:${this.newPrice}_pax:${this.numTravellers}_meta`);
        this.toggleTemplate(false);
        if (isDynpack) {
            Odigeo.trigger(this.id + ':onBackToResults', 'accommodation');
        } else {
            const searchParameters = Odigeo.Utils.parseJson(Odigeo.Session.get('searchParameters'));
            Odigeo.Router.navigate('results', {params: Flights.searchParamsStringify(searchParameters), removeParametersFromQueryString: isDesktop});
        }
        if (!isDesktop) {
            Odigeo.Router.reload();
        }
    },
    confirmRepricing(event) {
        trackClickEvent(event);
        trackingUtils.trackEvent('repricing_popup',
            `repricing_continue_iprice:${this.oldPrice}_fprice:${this.newPrice}_pax:${this.numTravellers}_meta`);
        this.toggleTemplate(false);
        let page;
        if (isDesktop) {
            page = Odigeo.AB.isFecoCheckoutPassengersDesktop ? 'checkout_passengers' : 'details';
        } else {
            page = Odigeo.AB.isFecoCheckoutPassengersMobile ? 'checkout_passengers' : 'passengersinfo';
        }
        const bookingId = Odigeo.Session.get('bookingId');

        if (isDynpack) {
            Odigeo.trigger(this.id + ':onAcceptRepricing');
        } else {
            fareRulesManager.then((action = fareRuleEvents.GO_TO_PAX) => {
                if (action === fareRuleEvents.GO_TO_FARE_RULES) {
                    Odigeo.Router.navigate(Odigeo.AB.isFarePlusOF2Mobile ? 'flexibility_bundle' : 'fare-rules', {bookingId});
                } else {
                    Odigeo.Router.navigate(page, {bookingId});
                }
            });
        }
    },
});
